import React from 'react';
import { generateColorForAsset } from '../utils/colorUtils';
import './Avatar.css';

function Avatar({ user, size = 32, className = '' }) {
  const avatarSize = `${size}px`;
  const fontSize = `${Math.round(size * 0.4)}px`;
  
  if (user?.avatar) {
    return (
      <img
        src={user.avatar}
        alt={`${user.name}'s avatar`}
        className={`avatar avatar-image ${className}`}
        style={{ width: avatarSize, height: avatarSize }}
      />
    );
  }
  
  // Default to initials with user's booking color
  const backgroundColor = generateColorForAsset(user?.id || 'default');
  const initials = user?.name ? user.name.charAt(0).toUpperCase() : '?';
  
  return (
    <div
      className={`avatar avatar-initials ${className}`}
      style={{
        width: avatarSize,
        height: avatarSize,
        backgroundColor,
        fontSize
      }}
    >
      {initials}
    </div>
  );
}

export default Avatar;
